import {createEffect, createSignal, onMount, Show} from 'solid-js'
import {LoadingScreen, useConfig} from '../../libs/foundation/components'
import {useDispatch, useSelector} from '../../libs/foundation/store'
import {getAdminUserProfile} from 'store-actions'
import {getDeviceInfo, LocalStorageKeys} from '../../libs/foundation/utils'
import {isEmpty} from 'lodash'
import {
    CareAgentAuthorizationHandler,
    CareAgentAuthorizationType,
    CareAgentAuthorizerOptions,
} from './CareAgentAuthorizationHandler'
import {CareAgentAuthorizationContext} from './CareAgentAuthorizationContext'

interface CareAgentAuthorizationProviderProps {
    voltApi: any
    children: any
}
export const CareAgentAuthorizationProvider = (props: CareAgentAuthorizationProviderProps) => {
    const [authorizationHandler, setAuthorizationHandler] = createSignal<CareAgentAuthorizationHandler>()
    const profile = useSelector(state => state.careportal.profile)
    const unsupportedDeviceTypes = ['smartphone', 'tablet', 'phablet']
    const isDeviceUnSupported = unsupportedDeviceTypes.includes(getDeviceInfo().device?.type ?? 's')
    const [waitForProfile, setWaitForProfile] = createSignal(false)
    const {getConfig} = useConfig()
    const dispatch = useDispatch()

    const authConfig: CareAgentAuthorizerOptions = {
        allowGuest: getConfig().allowGuest,
        agentClientId: getConfig().carePortal.agentClientId,
        clientSecret: getConfig().carePortal.ssoClientSecret,
        redirectUri: location.origin + '/agent',
        authorizationType: CareAgentAuthorizationType.REDIRECT,
        responseType: CareAgentAuthorizationType.TOKEN,
        grant_type: getConfig().grant_type,
        scope: getConfig().carePortal.OAuthParam.scope,
        authorityConfiguration: {
            authorization_endpoint: getConfig().carePortal.urls.adminAuthUrl + getConfig().OAuthParam.endpoint.auth,
            token_endpoint: getConfig().OAuthParam.endpoint.fullTokenUrl
                ? getConfig().OAuthParam.endpoint.fullTokenUrl
                : getConfig().carePortal.urls.adminAuthUrl + getConfig().OAuthParam.endpoint.token,
            revocation_endpoint: '',
            registration_endpoint: '',
        },
        extras: {
            ...getConfig().carePortal.OAuthParam.extras,
            'x-ulm-sso-clientId': getConfig().carePortal.ssoClientId,
        },
    }

    createEffect(() => {
        if (!isEmpty(profile())) {
            setWaitForProfile(false)
        }
    })

    onMount(async () => {
        const _authzHandler = new CareAgentAuthorizationHandler(authConfig)
        setAuthorizationHandler(_authzHandler)
        if (window.location.pathname !== '/agent/search' && !isDeviceUnSupported) {
            if (!authConfig.allowGuest && localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) !== null) {
                setWaitForProfile(true)
            }
            if (isEmpty(profile()) && localStorage.getItem(LocalStorageKeys.OIDC_OAUTH_TOKEN) === null) {
                setWaitForProfile(true)
                return dispatch(
                    getAdminUserProfile({
                        onSuccess: () => {
                            // navigate(_authzHandler?.getCbRedirectUrl?.() || 'agent/search')
                        },
                        onError: () => {
                            setWaitForProfile(false)
                        },
                    })
                )
            }
        }
        if (authConfig.allowGuest) {
            setWaitForProfile(false)
        }
    })

    return (
        <CareAgentAuthorizationContext.Provider value={{authorizationHandler: () => authorizationHandler() as any}}>
            <Show when={waitForProfile()} fallback={props.children}>
                <LoadingScreen />
            </Show>
        </CareAgentAuthorizationContext.Provider>
    )
}

export interface CareAgentAuthorizationProviderBehavior {
    authorizationHandler: () => CareAgentAuthorizationHandler
}
